<template>
    <div no-body :title="$tc('message.register',2)">
        <b-card-body >
            <div class="row">
                <div class="row col-12 mb-4 shadow bg-white rounded premsbloc">
                    <div class=" col-12 col-md-7">
                        <h2 class="card-header new-title text-center">Historique des affiliations</h2>
                        <div class="card-body">
                            <div v-for="(contrat, index) in affiliations" :key="'affiliations'+index">
                                <span class="shadow bg-white d-flex align-items-center justify-content-between p-3 mb-2 rounded">
                                    <span>
                                        <i class="fa fa-calendar text-primary" aria-hidden="true"></i>
                                        <span class="text-primary mx-1">{{ today(contrat.date_signature) }}</span> - 
                                        <span class="mr-3">{{ contrat.title }} | {{ contrat.cim }}</span> 
                                        
                                        <span class="text-danger" v-if="contrat.statut == 'NON PAYÉ' || contrat.statut == 'NON PAYE'">
                                            <i class="fa fa-exclamation-circle text-danger"></i>
                                            <strong> Non Payé </strong>
                                        </span>
                                        
                                        <span class="text-primary" v-if="contrat.statut == 'PAYÉ' || contrat.statut == 'PAYE'">
                                            <i class="fa fa-check text-primary" aria-hidden="true"></i>
                                            <strong> Payé </strong>
                                        </span>
                                    </span>
                                    <i class="fas fa-check-circle fa-2x text-success" 
                                    v-if="contrat.statut == 'PAYÉ' || contrat.statut == 'PAYE'"></i>
                                </span>
                                <div v-for="(historique, key) in contrat.historiques" :key="'historique'+key">
                                    <div v-if="historique != null">
                                        <p class="shadow bg-white p-3 mb-2 rounded" v-if="historique['date_debut']">La date de début est passée du <span class="font-weight-bold">{{ historique['date_debut']['before'] }}</span> au <span class="font-weight-bold">{{ historique['date_debut']['after'] }}</span></p>
                                        <p class="shadow bg-white p-3 mb-2 rounded" v-if="historique['date_fin']"><i class="far fa-dot-circle fa-2x text-success" aria-hidden="true"></i> --- La date de fin est passée du <span class="font-weight-bold">{{ historique['date_fin']['before'] }}</span> au <span class="font-weight-bold">{{ historique['date_fin']['after'] }}</span></p>
                                        <p class="shadow bg-white p-3 mb-2 rounded" v-if="historique['date_signature']"><i class="far fa-dot-circle fa-2x text-success" aria-hidden="true"></i> --- La date de signature est passée du <span class="font-weight-bold">{{ historique['date_signature']['before'] }}</span> au <span class="font-weight-bold">{{ historique['date_signature']['after'] }}</span></p>
                                        <p class="shadow bg-white p-3 mb-2 rounded" v-if="historique['status_contrat']"><i class="fas fa-check-circle fa-2x text-success"></i> --- <span class="text-primary">{{ today(contrat.date_signature) }}</span> - Le statut de paiement du contrat est passée de <span class="font-weight-bold">{{ historique['status_contrat']['before'] }}</span> à <span class="font-weight-bold">{{ historique['status_contrat']['after'] }}</span></p>
                                        <p class="shadow bg-white p-3 mb-2 rounded" v-if="historique['status_paiement']"><i class="far fa-dot-circle fa-2x text-success" aria-hidden="true"></i> --- Le statut de paiement est passée de <span class="font-weight-bold">{{ historique['status_paiement']['before'] }}</span> à <span class="font-weight-bold">{{ historique['status_paiement']['after'] }}</span></p>
                                        <p class="shadow bg-white p-3 mb-2 rounded" v-if="historique['renouvelle']"><i class="far fa-dot-circle fa-2x text-success" aria-hidden="true"></i> --- <span class="font-weight-bold">{{ historique['renouvelle']['before'] == "oui" ? "Renouvellement du contrat" : "Signature du contrat" }}</span> à <span class="font-weight-bold">{{ historique['renouvelle']['after'] == "oui" ? "Renouvellement du contrat" : "Signature du contrat" }}</span></p>
                                        <p class="shadow bg-white p-3 mb-2 rounded" v-if="historique['expire']"><i class="fa fa-exclamation-circle text-danger"></i> --- L'expiration est passé de  <span class="font-weight-bold">{{ historique['expire']['before'] }}</span> à <span class="font-weight-bold">{{ historique['expire']['after'] }}</span></p>
                                        <p class="shadow bg-white p-3 mb-2 rounded" v-if="historique['niveau_urgence']"><i class="fa fa-check text-primary" aria-hidden="true"></i> --- Le niveau d'urgence est passé de <span class="font-weight-bold">{{ historique['niveau_urgence']['before'] }}</span> à <span class="font-weight-bold">{{ historique['niveau_urgence']['after'] }}</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col col-md-5">
                        <h2 class="font-weight-bold card-header new-title text-center">Informations des affiliations</h2>
                        <div class="font-weight-bold card-body">
                            <div v-for="(contrat, key) in affiliations" :key="key">
                                <div class="font-weight-bold list-group-item mt-3">
                                    <span class="font-weight-bold new-title">Nom: </span><span class="text-primary"> {{ contrat.cim }}</span>
                                </div>
                                <div class="font-weight-bold list-group-item"> 
                                    <span class="new-title">Type: </span><span class="font-weight-bold text-primary"> {{ contrat.typeSouscription }}</span>
                                    </div>
                                <div class="font-weight-bold list-group-item "> 
                                    <span class="new-title">Montant: </span><span class="font-weight-bold text-primary">{{ displayNumber(contrat.montantSouscription) }} </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="font-weight-bold row col-12 mb-4 shadow bg-white rounded deusbloc">
                    <div class="col">
                        <h2 class="font-weight-bold card-header new-title text-center">Informations du souscripteur</h2>
                        <div class="card-body">
                            <div class="list-group-item"><p class="ligne"><span class="new-title">Nom et prénom</span>: <span class="font-weight-bold text-gray mr-4">{{parseNameAndSurname(contrat.nomSouscripteur,contrat.prenomSouscripteur)}}</span></p></div>
                            <div class="list-group-item"><p class="ligne"><span class="mr-2 new-title">pays:</span><span class="font-weight-bold text-gray">{{ contrat.paysResidenceSouscripteur }}</span></p></div>
                            <div class="list-group-item"><p class="ligne"><span class="new-title">Ville</span>: <span class="font-weight-bold text-gray mr-4">{{ contrat.villeResidenceSouscripteur }}</span></p></div>
                            <div class="list-group-item"><p class="ligne"><span class="mr-2 new-title">Téléphone:</span><span class="font-weight-bold text-gray"><p>{{ contrat.telephoneSouscripeur1 }}</p></span></p></div>
                            <div class="list-group-item"><p class="ligne"><span class="new-title">Email</span>: <span class="font-weight-bold text-gray mr-2">{{ contrat.emailSouscripteur1 }}</span></p></div>
                            <div class="list-group-item"><p class="ligne"><span class="mr-2 new-title">Sexe:</span><span class="font-weight-bold text-gray">{{ contrat.sexeSouscripteur }}</span></p></div> 
                        </div>
                    </div>
                    <div class="col">
                        <h2 class="font-weight-bold card-header new-title text-center">Informations du patient</h2>
                        <div class="card-body">
                            <div class="font-weight-bold list-group-item"><p class="ligne"><span class="new-title">Nom et prénom</span>: <span class="font-weight-bold text-gray mr-4">{{parseNameAndSurname(contrat.nomAffilie,contrat.prenomAffilie)}}</span></p></div>
                            <div class="list-group-item"><p class="ligne"><span class="font-weight-bold mr-2 new-title">pays:</span><span class="font-weight-bold text-gray">{{ contrat.paysResidenceAffilie }}</span></p></div>
                            <div class="list-group-item"><p class="ligne"><span class="font-weight-bold new-title">Ville</span>: <span class="font-weight-bold text-gray mr-4">{{ contrat.villeResidenceAffilie }}</span></p></div>
                            <div class="list-group-item"><p class="ligne"><span class="font-weight-bold mr-2 new-title">Téléphone: </span><span class="font-weight-bold text-gray">{{ contrat.telephoneSouscripeur1 }}</span></p></div>
                            <div class="list-group-item"><p class="ligne"><span class="new-title">Email</span>: <span class="font-weight-bold text-gray mr-4">{{ contrat.emailSouscripteur1 }}</span></p></div>
                            <div class="list-group-item"><p class="ligne"><span class="mr-2 new-title">Sexe:</span><span class="font-weight-bold text-gray">{{ contrat.sexeAffilie }}</span></p></div>
                            <div class="list-group-item"><p class="ligne"><span class="new-title">Date de naissance</span>: <span class="font-weight-bold text-gray mr-4">{{!!getBirthDateOrBornAroundYear(contrat.dateNaissanceAffilie,contrat.bornAroundAffilie) ? $t(getBirthDateOrBornAroundYear(contrat.dateNaissanceAffilie,contrat.bornAroundAffilie).message) + " " + formattedDate(getBirthDateOrBornAroundYear(contrat.dateNaissanceAffilie,contrat.bornAroundAffilie).date): $t("message.notSpecified")}}</span></p></div>
                        </div>
                    </div>
                </div>
            </div> 
        </b-card-body>
    </div>
</template>

<script>

import axios from 'axios';
import AppConfig from "../../constants/AppConfig";
import moment from "moment";
import _ from "lodash";

export default {
    name: "Souscription",

    components: {},

    computed: {},
    props: ['dossier_medical_slug'],
    data() {
        return {
            affiliations: [],
            contrat: ""
        }
    },
    methods: {
        displayNumber(value) {
            if (typeof value === 'string' || value instanceof String){
                if(value.includes('.')){
                    return value +" XAF";
                }else{
                    return value.length > 4 ? value.toLocaleString("fr") + " XAF" : value.toLocaleString("fr") + " EUR" 
                }
            }else{
                return String(value).length > 4 ? Number(value).toLocaleString("fr") + " XAF" : Number(value).toLocaleString("fr") + " EUR" 
            }
            
            
        },
        formattedDateTime(date) {
            if (moment(date).isValid() && date != null) {
                return moment(date).format("DD-MM-YYYY à HH:mm");
            } else {
                return date;
            }
        },
        formattedDate(date) {
            if (moment(date).isValid()) {
                return moment(date).format("DD-MM-YYYY");
            } else {
                return date;
            }
        },
        today: function (date) {
            if (moment(date).isValid()) {
                return moment(date).format("DD-MM-YYYY");
            } else {
                return moment(new Date()).format("DD-MM-YYYY");
            }
        },
        displayDate(date) {
            return moment(date).format("dddd, MMMM Do YYYY, h:mm:ss a");
        },
        getBirthDateOrBornAroundYear(birthDate, bornAround) {
            if (birthDate && birthDate !== "")
                return {
                message: "",
                date: birthDate,
                };
            else if (bornAround && bornAround !== "")
                return {
                message: "message.bornAround",
                date: bornAround,
                };
            return null;
        },
        parseNameAndSurname(name, surname) {
            if (_.isUndefined(name) || _.isNull(name)) return "";
            name = name.toUpperCase();

            if (_.isUndefined(surname) || _.isNull(surname)) {
                return name;
            } else {
                if (surname.length > 0) {
                
                surname = _.startCase(surname);
                }
            }

            return name + " " + surname;
        },
        getAffiliations(dossier_medical_slug){
            axios.get(`${AppConfig.apiUrl}/v1/parcours/${dossier_medical_slug}/affiliations`, {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }})
            .then(res => {
                res.data.affiliations.forEach(affiliation => {
                    affiliation.date_signature = affiliation.created_at;
                    affiliation.statut = affiliation.statut_paiement;
                    affiliation.title = affiliation.renouvelle == "oui" ? "Renouvellement du contrat" : "Signature du contrat";
                
                    if(affiliation.changes != null){
                        affiliation.historiques = affiliation.changes.map(item => JSON.parse(item.changes)).filter(item => item.length > 0 );
                    }
                    this.affiliations = [...this.affiliations, affiliation];
                    this.contrat = this.affiliations.length > 0 ? this.affiliations[0] : ""
                })
            })
            .catch((error) => {
                    //
            });
        }
    },
    mounted() {
        this.getAffiliations(this.dossier_medical_slug);
    }
}
</script>